/**
 * 复制文本到剪贴板
 *
 * 微信内置浏览器（尤其 iOS）对 navigator.clipboard 支持不稳定：
 * 非 HTTPS、非用户手势触发、旧版 WebView 都可能拿不到 API 或直接抛错，
 * 所以必须保留 execCommand 兜底。两条路都失败时返回 false，
 * 由调用方提示用户长按选中手动复制。
 *
 * @param {string} text
 * @returns {Promise<boolean>} 是否复制成功
 */
export async function copyText(text) {
  if (!text) return false;
  const str = String(text);

  // 优先新 API（HTTPS + 支持的环境）
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(str);
      return true;
    }
  } catch (e) {
    // 落到下面的兜底
  }

  // 兜底：execCommand（兼容微信 WebView / 老 iOS Safari）
  try {
    const input = document.createElement("textarea");
    input.value = str;
    input.style.position = "fixed";
    input.style.top = "-9999px";
    input.style.opacity = "0";
    input.setAttribute("readonly", "readonly");
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, str.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(input);
    return ok;
  } catch (e) {
    return false;
  }
}
